import React from 'react';
import '../CSS/Profile/DinaAlkikiProfile.css';

const DinaAlkikiProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/dina-alkiki.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Dina Alkiki"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Dina Alkiki</h1>
        <div className="profile-title-container">
          <p className="profile-title">Associate Vice President of Operations and Finance</p>
          <a href="https://www.linkedin.com/in/dina-alkiki/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            <strong>Dina Alkiki</strong> joined Myers McRae in 2023 as Associate Vice President of Operations and Finance. Her diverse business experience includes highly recognized and worldwide organizations, as well as smaller specialized companies. She has worked at KPMG Jordan (financial analysis, market research), on advertising campaigns for Samsung, and held leadership positions in quality assurance and development at Housing Bank for Trading and Finance (HBTF).
          </p>
          <p>
            Her skills include initiating competitive projects, recruiting potential partners, evaluating and monitoring employees' operations, providing training, and refocusing employees to meet guidelines.
          </p>
          <p>
            She holds a Bachelor of Arts degree in finance from the University of Jordan and a Master of Business Administration degree with a concentration in innovation and entrepreneurship from Mercer University. She is multilingual in English, Arabic, and French.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DinaAlkikiProfile;

